(() => {
  let dispose = () => {};
  const initialise = () => {
    dispose();
    const controller = new AbortController();
    const { signal } = controller;
    const observers = [];
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0;
    const header = document.querySelector('[data-nb-header]');
    const headerSection = header?.closest('.nb-header-section');
    const announcement = document.querySelector('[data-nb-announcement]');
    const progress = document.querySelector('[data-nb-progress]');
    const discovery = document.querySelector('[data-nb-discovery]');
    const home = document.querySelector('[data-nebuline-home]');
    const hero = home?.querySelector('.nb-home-hero');
    const product = home?.querySelector('[data-nb-product]');
    const footer = document.querySelector('.nb-footer');
    const menus = [...document.querySelectorAll('.nb-mobile-menu')];
    const landmarks = [...document.querySelectorAll('#air-styler, #rituel, #questions')];
    const navLinks = [...document.querySelectorAll('.nb-desktop-nav a, .nb-mobile-menu nav a')];

    const update = () => {
      frame = 0;
      const headerHeight = header?.offsetHeight || 0;
      const announcementHeight = announcement?.offsetHeight || 0;
      const maxScroll = document.documentElement.scrollHeight - innerHeight;
      const fraction = maxScroll > 0 ? Math.min(1, Math.max(0, scrollY / maxScroll)) : 0;
      let current = '';
      for (const landmark of landmarks) {
        if (landmark.getBoundingClientRect().top <= headerHeight + innerHeight * .22) current = landmark.id;
      }
      const productBounds = product?.getBoundingClientRect();
      const productVisible = productBounds && productBounds.top < innerHeight - 80 && productBounds.bottom > headerHeight;
      const footerVisible = footer && footer.getBoundingClientRect().top < innerHeight;
      const showDiscovery = innerWidth <= 740 && hero && hero.getBoundingClientRect().bottom < headerHeight && !productVisible && !footerVisible && !menus.some(menu => menu.open);
      document.documentElement.style.setProperty('--nb-header-size', headerHeight + 'px');
      headerSection?.style.setProperty('--nb-announcement-height', announcementHeight + 'px');
      headerSection?.classList.toggle('is-scrolled', scrollY > announcementHeight);
      if (progress) progress.style.transform = 'scaleX(' + fraction + ')';
      navLinks.forEach(link => {
        if (current && link.hash === '#' + current) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      if (discovery) discovery.hidden = !showDiscovery;
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener('scroll', schedule, { passive: true, signal });
    window.addEventListener('resize', schedule, { passive: true, signal });
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(schedule);
      [header, document.querySelector('main')].filter(Boolean).forEach(element => observer.observe(element));
      observers.push(observer);
    }

    menus.forEach(menu => {
      const summary = menu.querySelector('summary');
      menu.addEventListener('click', event => { if (event.target.closest('a')) menu.open = false; }, { signal });
      menu.addEventListener('toggle', schedule, { signal });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.open = false; summary.focus(); }
      }, { signal });
    });

    document.addEventListener('click', event => {
      menus.forEach(menu => { if (menu.open && !menu.contains(event.target)) menu.open = false; });
      if (event.target.closest('[data-nebuline-continue]')) document.querySelector('cart-drawer')?.close();
      const link = event.target.closest('a[href*="#"]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash) return;
      const destination = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!destination) return;
      event.preventDefault();
      const target = link.matches('[data-nb-discovery-link]') ? destination.querySelector('h2') || destination : destination;
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      target.scrollIntoView({ behavior: motion.matches ? 'instant' : 'smooth', block: 'start' });
      history.replaceState(history.state, '', url.hash);
    }, { signal });

    const cart = document.querySelector('cart-drawer');
    cart?.setHeaderCartIconAccessibility?.();
    const cartLink = document.querySelector('#cart-icon-bubble');
    let count = Number(cartLink?.querySelector('.nb-cart-count')?.textContent) || 0;
    if (cartLink) {
      const observer = new MutationObserver(() => {
        const badge = cartLink.querySelector('.nb-cart-count');
        const nextCount = Number(badge?.textContent) || 0;
        if (nextCount > count && !motion.matches) badge?.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.3)' }, { transform: 'scale(1)' }], { duration: 320, easing: 'ease-out' });
        count = nextCount;
      });
      observer.observe(cartLink, { childList: true, subtree: true, characterData: true });
      observers.push(observer);
    }
    if (discovery && home) {
      const price = home.querySelector('[data-nb-price]');
      const destination = discovery.querySelector('[data-nb-discovery-price]');
      const syncPrice = () => { if (price && destination) destination.textContent = price.textContent; };
      syncPrice();
      if (price) {
        const observer = new MutationObserver(syncPrice);
        observer.observe(price, { childList: true, characterData: true, subtree: true });
        observers.push(observer);
      }
    }

    document.querySelectorAll('[data-nebuline-sticky]').forEach(bar => {
      const form = document.querySelector('.product__info-container .product-form');
      const main = document.querySelector('[id^="MainProduct-"]');
      if (!form || !main) return;
      const link = bar.querySelector('[data-nebuline-product-options]');
      link.href = '#' + main.id;
      link.addEventListener('click', event => {
        event.preventDefault();
        main.scrollIntoView({ behavior: motion.matches ? 'instant' : 'smooth' });
        main.querySelector('variant-selects input:not(:disabled), variant-selects select:not(:disabled), .product-form__submit:not(:disabled)')?.focus({ preventScroll: true });
      }, { signal });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => { bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; });
        observer.observe(form);
        observers.push(observer);
      }
    });

    update();
    dispose = () => {
      controller.abort();
      observers.forEach(observer => observer.disconnect());
      if (frame) cancelAnimationFrame(frame);
    };
  };
  document.addEventListener('DOMContentLoaded', initialise, { once: true });
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('shopify:section:unload', () => { dispose(); requestAnimationFrame(initialise); });
  if (document.readyState !== 'loading') initialise();
})();
